import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import {
  getUsers as getUsersApi,
  updateUserStatusApi,
  blockUserApi
} from "../../helpers/api/users";

// constants
import { UserActionTypes } from "./constants";
import {
  getUserData,
  UsersApiResponseSuccess,
  UsersDataApiResponseError,
} from "./actions";

function* getUsersDatas(): SagaIterator {
  try {
    const response = yield call(getUsersApi);
    const users = response?.data?.data;

    yield put(UsersApiResponseSuccess(UserActionTypes.GET_USER_DATA, users));
  } catch (error: any) {
    yield put(UsersDataApiResponseError(UserActionTypes.GET_USER_DATA, error));
  }
}

function* updateUserStatusSaga({ payload: { userId, status } }: any): SagaIterator {
  try {
    const response = yield call(updateUserStatusApi, { userId, status });
    const message = response?.data?.message;

    yield put(UsersApiResponseSuccess(UserActionTypes.ACTIVATE_USER, message));
    yield put(getUserData());
  } catch (error: any) {
    yield put(UsersDataApiResponseError(UserActionTypes.ACTIVATE_USER, error));
  }
}

function* blockUserSaga({ payload: { userId } }: any): SagaIterator {
  try {
    const response = yield call(blockUserApi, userId);
    const message = response?.data?.message;

    yield put(UsersApiResponseSuccess(UserActionTypes.BLOCK_USER, message));
    yield put(getUserData());
  } catch (error: any) {
    yield put(UsersDataApiResponseError(UserActionTypes.BLOCK_USER, error));
  }
}

export function* watchGetUsers() {
  yield takeEvery(UserActionTypes.GET_USER_DATA, getUsersDatas);
}

export function* watchUpdateUserStatus() {
  yield takeEvery(UserActionTypes.ACTIVATE_USER, updateUserStatusSaga);
}

export function* watchBlockUser() {
  yield takeEvery(UserActionTypes.BLOCK_USER, blockUserSaga);
}

function* UsersSaga() {
  yield all([
    fork(watchGetUsers),
    fork(watchUpdateUserStatus),
    fork(watchBlockUser),
  ]);
}

export default UsersSaga;